<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-icon class="icon" :color="color" v-on="on"> {{ icon }}</v-icon>
    </template>
    <span> {{ text }}</span>
  </v-tooltip>
</template>
<script>
export default {
  props: {
    ativo: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    icon() {
      return this.ativo ? 'mdi-check-circle' : 'mdi-cancel';
    },
    color() {
      return this.ativo ? 'success' : 'error';
    },
    text() {
      return this.ativo ? 'Ativo' : 'Inativo';
    },
  },
};
</script>
<style scoped>
.icon {
  font-size: 20px;
}
</style>
